import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type T3Horizon = 5 | 10 | 15 | 20;

@Injectable({ providedIn: 'root' })
export class T3YearStore {
  private horizonSubject = new BehaviorSubject<T3Horizon>(5);
  horizon$ = this.horizonSubject.asObservable();

  private yearSubject = new BehaviorSubject<number>(2031);
  year$ = this.yearSubject.asObservable();

  setHorizon(horizon: T3Horizon): void {
    this.horizonSubject.next(horizon);

    const targetYear =
      horizon === 5 ? 2031 :
      horizon === 10 ? 2036 :
      horizon === 15 ? 2041 :
      2046;

    this.yearSubject.next(targetYear);
  }

  setYear(year: number): void {
    this.yearSubject.next(year);
  }
}